// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__KoQ2V","footer__link":"styles_footer__link__vZ2ES"};